var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",attrs:{"id":"index"}},[_c('div',{staticClass:"header"},[_c('Header',{staticClass:"box"})],1),_c('div',{staticClass:"main-content"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('div',{staticClass:"footer-content"},[_c('Footer',{staticClass:"box"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }